import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseRelatedArticle() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      masterFaName: isEmpty(state.masterFaName),
      relatedFaName: isEmpty(state.relatedFaName),
    };

    setter(errorState);

    if (errorState.masterFaName || errorState.relatedFaName) {
      enqueueSnackbar("لطفا اطلاعات  را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getRelatedList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_RelatedArticle?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllRelatedList = (callback) => {
    MyAxios.get(`Admin_RelatedArticle?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const addRelated = (related, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(related));
    MyAxios.post(`Admin_RelatedArticle`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteRelated = (model, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(model));
    MyAxios.delete(`Admin_RelatedArticle`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const GetArticles = (search, myPC, callback) => {
    MyAxios.get(`Admin_Articles?w=${search}`, {
      headers: {
        IsPage: true,
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Default",
            sortOrder: "Desc",
            searchColumn: "",
            forceRefresh: true,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetArticleByID = (ArticleID, callback) => {
    MyAxios.get(`Admin_Articles/${ArticleID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    getRelatedList,
    getAllRelatedList,
    validate,
    addRelated,
    deleteRelated,
    GetArticles,
    GetArticleByID,
  };
}
